module.exports = __webpack_public_path__ + "img/icon-list-view-light.e830f876.svg";